import React from 'react'

import Input from 'app/components/Input'
import { IInputStepProps } from './interface'
import WrapperStep from '../WrapperStep'

const InputStep: React.FC<IInputStepProps> = ({ isActive, meta, invalid, ...props }) => {
  return (
    <WrapperStep btnText="Continue" disabled={meta.touched && meta.error} invalid={invalid} {...props}>
      <Input {...props} autoFocus={isActive} meta={meta} />
    </WrapperStep>
  )
}

export default InputStep
